module.exports = __webpack_public_path__ + "assets/img/menu-files.a230143c.svg";